import TopDepartmentScore from "./TopDepartmentScore";
import SalesAchivementPage from "./SalesAchivementPage";
import OverallAchivementPage from "./OverallAchivementPage";
import "../App.css";

export default function TopDepartmentAchivementPage({ activeDoerEmail }) {
  return (
    <div className="achievementGrid">

      <div className="achievementItem">
        <TopDepartmentScore activeDoerEmail={activeDoerEmail} />
      </div>

      <div className="achievementItem">
        <OverallAchivementPage />
      </div>

      <div className="achievementItem">
        <SalesAchivementPage />
      </div>

    </div>
  );
}